import React, { Fragment } from 'react';

const HighlightMentions = ({ text }) => {
    const mentionRegex = /(^|\s)(@\w+)\b/g;
    const parts = [];
    let lastIndex = 0;

    (text || '').replace(mentionRegex, (match, before, mention, offset) => {
        if (offset > lastIndex) {
            parts.push(
                <span key={`text-${lastIndex}`}>
                    {text.substring(lastIndex, offset)}
                </span>
            );
        }

        parts.push(
            <strong key={`mention-${offset}`} style={{ fontWeight: 'bold' }}>
                {before + mention}
            </strong>
        );

        lastIndex = offset + match.length;
    });

    if (lastIndex < text.length) {
        parts.push(
            <span key={`text-${lastIndex}`}>
                {text.substring(lastIndex)}
            </span>
        );
    }

    return <>{parts}</>;
};

const LinkHighlighter = ({ text, color }) => {
    const cleanedText = (text || '').replace(/(https?:\/\/)/g, ' $1').trim();
    const urlRegex = /https?:\/\/[^\s]+/g;
    const parts = cleanedText.split(/(https?:\/\/[^\s]+)/g);

    return (
        <Fragment>
            {parts?.map((part, index) =>
                urlRegex.test(part) ? (
                    <a
                        key={`link-${index}`}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline italic"
                        style={{ color: color }}
                    >
                        {part}
                    </a>
                ) : (
                    <span key={`text-${index}`}>
                        <HighlightMentions text={part} />
                    </span>
                )
            )}
        </Fragment>
    );
};

export default LinkHighlighter;
